export function convertToLocaleNumber(num: number | string, locale: string): string {
  const numValue = typeof num === 'string' ? parseInt(num, 10) : num;
  
  // Arabic-Indic numerals for Arabic
  if (locale === 'ar') {
    const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return numValue.toString().split('').map(digit => arabicNumerals[parseInt(digit)]).join('');
  }
  
  // Persian numerals for Farsi
  if (locale === 'fa') {
    const persianNumerals = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return numValue.toString().split('').map(digit => persianNumerals[parseInt(digit)]).join('');
  }
  
  // Default to standard numerals
  return numValue.toString();
}

export function formatPercentage(value: number, locale: string): string {
  const numStr = convertToLocaleNumber(value, locale);
  
  if (locale === 'ar') {
    return `${numStr}٪`; // Arabic percent sign
  }
  
  if (locale === 'fa') {
    return `${numStr}٪`; // Persian percent sign
  }
  
  return `${numStr}%`;
}

export function formatCurrency(value: number, locale: string, currency: string = '€'): string {
  const numStr = convertToLocaleNumber(value, locale);
  
  if (locale === 'ar' || locale === 'fa') {
    return `${numStr} ${currency}`;
  }
  
  return `${currency}${numStr}`;
}

export function formatNumberWithText(number: number | string, text: string, locale: string): string {
  const numStr = convertToLocaleNumber(number, locale);
  
  if (locale === 'ar' || locale === 'fa') {
    return `${numStr} ${text}`;
  }
  
  return `${text} ${numStr}`;
}

export function formatTextWithNumbers(text: string, locale: string): string {
  // Simple passthrough - translation files now have correct format
  return text;
}